import Component, { mixins } from 'vue-class-component'

import WithRender from './OverviewInscriptionOffreCours.html'

import {
  MButton,
  MMessage,
  MMessageState,
  MModal,
  MModalSize,
  MPanel,
  MSpinner,
  MSwitch
} from '@ulaval/modul-components'

import InscriptionLieuExamenService from '../InscriptionLieuExamen.service'

import ROUTES from '@/router/ROUTES'
import { STORE_GETTERS } from '@/store'

import IOverviewInscriptionOffreCours from './IOverviewInscriptionOffreCours.model'
import IInscriptionLieuExamenInformations from '../IInscriptionLieuExamenInformations.model'
import IDossierEtudiant from '../IDossierEtudiant.model'

@WithRender
@Component({
  components: {
    MButton,
    MMessage,
    MModal,
    MPanel,
    MSpinner,
    MSwitch
  }
})
export default class OverviewInscriptionOffreCours extends mixins(InscriptionLieuExamenService) {
  private inscriptionsOffreCours: Array<IOverviewInscriptionOffreCours> = []
  private isInscriptionsLieuExamenTousCampus: boolean = false

  private isOverviewInscriptionsOffreCoursLoadingStateActive: boolean = false
  private isTousCampusButtonLoadingStateActive: boolean = false

  private readonly MMessageState: object = MMessageState
  private readonly MModalSize: object = MModalSize

  private get dossierEtudiant(): IDossierEtudiant | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_DOSSIER_ETUDIANT]
  }

  private get inscriptionLieuExamenInformations(): IInscriptionLieuExamenInformations | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_INFORMATIONS]
  }

  private get isNextStepFormAvailable(): boolean {
    return !!(this.inscriptionLieuExamenInformations) && 
    !this.isOverviewInscriptionsOffreCoursLoadingStateActive &&
    this.inscriptionsOffreCours.length > 0
  }

  private created(): void {
    this.loadOverviewInscriptionsOffreCours()
  }

  private loadOverviewInscriptionsOffreCours(): void {
    this.isOverviewInscriptionsOffreCoursLoadingStateActive = true

    this.service_inscriptionLieuExamenService_fetchOverviewInscriptionsOffreCours(this.$route.params.token)
      .then((response: Array<IOverviewInscriptionOffreCours>) => {
        this.inscriptionsOffreCours = response || []
      }).catch(() => {
        this.inscriptionsOffreCours = []
      }).finally(() => {
        this.isOverviewInscriptionsOffreCoursLoadingStateActive = false
      })
  }

  private onTousCampusButtonClick(): void {
    this.isTousCampusButtonLoadingStateActive = true

    this.service_inscriptionLieuExamenService_saveInscriptionsAsToutCampus(this.$route.params.token)
      .then(() => {
        this.navigateToNextStep()
      }).finally(() => {
        this.isTousCampusButtonLoadingStateActive = false
      })
  }

  private onNextStepButtonClick(): void {
    this.navigateToNextStep()
  }

  private navigateToNextStep(): void {
    this.mixin_router_navigate({
      name: ROUTES.INSCRIPTION_ETUDIANT_FORMULAIRE,
      params: this.$route.params
    })
  }
}
